import { render, staticRenderFns } from "./SectionOldTickets.vue?vue&type=template&id=32e4118d&scoped=true&"
import script from "./SectionOldTickets.vue?vue&type=script&lang=js&"
export * from "./SectionOldTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionOldTickets.vue?vue&type=style&index=0&id=32e4118d&prod&lang=sass&scoped=true&"
import style1 from "./SectionOldTickets.vue?vue&type=style&index=1&id=32e4118d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4118d",
  null
  
)

export default component.exports